import { createReducer } from '@reduxjs/toolkit';
import { closeEditTranslationComponent, showEditTranslationComponent } from 'redux/actions/edit-translations';
import { EditableCourseElements } from 'redux/schemas/models/edit-translations';
import { AccordionLectureComponentData, ComponentType, LectureComponent } from 'redux/schemas/models/lecture-component';
import { CourseOutlineItem, LectureOutlineItem } from 'redux/selectors/course-outline/course-outline-item';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder
    .addCase(showEditTranslationComponent, (state, action) => {
      let editViewOptions;
      let dataContent;
      let lectureSectionId;
      let lectureSubsectionId;

      const editableCourseElements = Object.values(EditableCourseElements) as string[];
      if (editableCourseElements.includes(action.payload.type)) {
        dataContent = (action.payload.component as CourseOutlineItem).name;
        if (action.payload.type === EditableCourseElements.LESSON) {
          if ((action.payload.component as LectureOutlineItem).sectionType === 'section') {
            lectureSectionId = (action.payload.component as LectureOutlineItem).section;
          } else {
            lectureSubsectionId = (action.payload.component as LectureOutlineItem).section;
          }
        }
      } else {
        editViewOptions = (action.payload.component as LectureComponent).viewOptions;
        if (action.payload.type === ComponentType.ACCORDION) {
          // For Accordions we need to get the array of sections,
          // and for the rest, it's just text.
          dataContent = (action.payload.component as AccordionLectureComponentData).accordionSections;
        } else {
          dataContent = (action.payload.component as LectureComponent).content;
        }
      }
      const info = {
        type: action.payload.type,
        trueType: action.payload.trueType,
        content: dataContent,
        viewOptions: editViewOptions,
        id: action.payload.component.id,
        // In case it's a course element
        lectureSectionId,
        lectureSubsectionId,
      };
      state.app.editTranslationInfo = info;
    })
    .addCase(closeEditTranslationComponent, (state, action) => {
      state.app.editTranslationInfo = null;
    });
});
